import { render, staticRenderFns } from "./vipText.vue?vue&type=template&id=c707f8a4&"
import script from "./vipText.vue?vue&type=script&lang=js&"
export * from "./vipText.vue?vue&type=script&lang=js&"
import style0 from "./vipText.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports